var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._l((_vm.fileList),function(item,index){return _c('div',{key:index},[_c('a',{on:{"click":function($event){return _vm.downloadExl(item.filepath)}}},[_vm._v(_vm._s(item.filename))])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }